import {useMatomo} from '@jonkoops/matomo-tracker-react';
import React, {ReactElement, useCallback} from 'react';

import WelcomeLogo from '../../../resources/animations/WelcomeLogo.json';
import Col from '../../common/Col';
import {useAppDispatch} from '../../store';
import {Actions} from '../gameSlice';
import NormalButton from './buttons/NormalButton';
import LottieAnimation from './LottieAnimation';

const Landing = (): ReactElement => {
  const dispatch = useAppDispatch();
  const {trackEvent} = useMatomo();

  const handleClickStart = useCallback(() => {
    trackEvent({
      category: 'game',
      action: 'button-click',
      name: 'play-game',
    });
    dispatch(Actions.startPlaying());
  }, [dispatch, trackEvent]);

  return (
    <Col className="space-y-xl mobile:space-y-md justify-center mobile:mt-[10rem]">
      <div role="heading" aria-level={1} aria-label={'Envirocrops Cropper'}>
        <LottieAnimation animation={WelcomeLogo} />
      </div>
      <NormalButton className="w-fit mx-auto min-w-[45rem] mobile:min-w-full" onClick={handleClickStart}>
        Let&apos;s grow!
      </NormalButton>
    </Col>
  );
};

export default Landing;
